import { SidebarProvider } from "@hooks/useSidebar";

export const LayoutProviders = ({ children }) => {
  return <SidebarProvider>{children}</SidebarProvider>;
};
